import { useTranslation } from 'react-i18next';
import { useModal } from 'context/ModalContext';
import { getButtonsNoYesDanger } from 'context/helpers/helperModalContext';
import SvgArchive from 'components/svg/SvgArchive';
import SvgTrash from 'components/svg/SvgTrash';

const useDeleteProduct = () => {
    const { t } = useTranslation(['Products']);
    const { showDlg } = useModal();

    const paramsDelDlg = {
        buttons: [...getButtonsNoYesDanger(t)],
        type: 'confirm',
    };

    const deleteProduct = (cbFunct: () => void) => {
        const p = {
            ...paramsDelDlg,
            text: (
                <h4 className="d-flex text-danger">
                    <SvgTrash className="text-danger" />
                    <span className="ps-2">{t('confirmDeleteProduct')}</span>
                </h4>
            ),
        };
        p.buttons[1].handleClick = () => {
            showDlg(false);
            cbFunct();
        };
        showDlg(p);
    };

    const archiveProduct = (cbFunct: () => void) => {
        const p = {
            ...paramsDelDlg,
            text: (
                <h4 className="d-flex text-danger">
                    <SvgArchive className="text-danger" />
                    <span className="ps-2">{t('confirmArchiveProduct')}</span>
                </h4>
            ),
        };
        p.buttons[1].handleClick = () => {
            showDlg(false);
            cbFunct();
        };
        showDlg(p);
    };

    return {
        deleteProduct,
        archiveProduct,
    };
};

export default useDeleteProduct;
